import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';

const useStyles = makeStyles(() => ({
    tabButton: {
        padding: '8px 16px',
        borderRadius: '8px',
        fontWeight: 500,
        textTransform: 'none',
        minWidth: 'auto',
    },
    active: {
        backgroundColor: '#14b8a6',
        color: '#ffffff',
        '&:hover': {
            backgroundColor: '#0d9488',
        },
    },
    inactive: {
        backgroundColor: '#f3f4f6',
        color: '#4b5563',
        '&:hover': {
            backgroundColor: '#e5e7eb',
        },
    },
}));

interface TabButtonProps {
    label: string;
    isActive: boolean;
    onClick: () => void;
}

export const TabButton: React.FC<TabButtonProps> = ({ label, isActive, onClick }) => {
    const classes = useStyles();
    return (
        <Button
            onClick={onClick}
            className={`${classes.tabButton} ${isActive ? classes.active : classes.inactive}`}
        >
            {label}
        </Button>
    );
};
